export const LocaleCodes = {
    enUS: 'en-US',
    frFR: 'fr-FR',
    itIT: 'it-IT',
    esLATAM: 'es-419', //Spanish (LATAM)
    deDE: 'de-DE',
    zhTW: 'zh-Hant-TW',
    jaJP: 'ja-JP',
    arAE: 'ar-AE',
    faIR: 'fa-IR',
    zhCN: 'zh-Hans-CN',
    ptBR: 'pt-BR', // Portuguese (Brazilian)
    esES: 'es-ES', // Spanish (European)
    koKR: 'ko-KR',
    hiIN: 'hi-IN',
    trTR: 'tr-TR',
    thTH: 'th-TH',
    ruRU: 'ru-RU',
    plPL: 'pl-PL',
    nlNL: 'nl-NL',
    ptPT: 'pt-PT', // Portuguese (European)
    svSE: 'sv-SE',
    nbNO: 'nb-NO',
    isIS: 'is-IS',
};
